import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=53b40748&scoped=true&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"
import style0 from "./Ending.vue?vue&type=style&index=0&id=53b40748&lang=less&scoped=true&"
import style1 from "./Ending.vue?vue&type=style&index=1&id=53b40748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b40748",
  null
  
)

export default component.exports